{
  "name": "blueprint-ui",
  "version": "1.7.12",
  "license": "MIT",
  "config": {
    "openapiArgs": "--additional-properties ngVersion=21 --additional-properties modelPropertyNaming=original --type-mappings=DateTime=Date",
    "deleteGeneratedCommand": "rimraf src/app/generated/blueprint.api/"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test",
    "lint": "ESLINT_USE_FLAT_CONFIG=false eslint -c .eslintrc.js --ext .ts src/",
    "e2e": "ng e2e",
    "swagger:gen": "curl --insecure http://localhost:4300/swagger/v1/swagger.json --output swagger.json && node_modules/@openapitools/openapi-generator-cli/bin/openapi-generator generate -i ./swagger.json -g typescript-angular -o src/app/generated/blueprint-api --additional-properties ngVersion=21 --additional-properties useRxJS6=true --additional-properties modelPropertyNaming=original --type-mappings=DateTime=Date --skip-validate-spec",
    "swagger:gen-docker": "docker run --rm -v \"$(pwd)\":/local openapitools/openapi-generator-cli:v7.15.0 generate -i http://host.docker.internal:4724/swagger/v1/swagger.json -g typescript-angular -o /local/src/app/generated/blueprint.api --additional-properties ngVersion=21 --additional-properties useRxJS6=true --additional-properties modelPropertyNaming=original --type-mappings=DateTime=Date --skip-validate-spec",
    "docker:init": "docker network create identity --driver=overlay",
    "docker:stack": "npm run docker:stack:identity && npm run docker:stack:api",
    "docker:stack:api": "docker stack deploy -c docker-compose.yml -c docker/compose/api.yml blueprint_stack",
    "docker:stack:identity": "docker stack deploy -c docker-compose.yml -c docker/compose/identity.yml identity_stack",
    "docker:destroy": "docker stack rm blueprint_stack identity_stack"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.1",
    "@angular/cdk": "^21.2.1",
    "@angular/common": "^21.2.1",
    "@angular/compiler": "^21.2.1",
    "@angular/core": "^21.2.1",
    "@angular/forms": "^21.2.1",
    "@angular/material": "^21.2.1",
    "@angular/material-luxon-adapter": "^21.2.1",
    "@angular/platform-browser": "^21.2.1",
    "@angular/platform-browser-dynamic": "^21.2.1",
    "@angular/router": "^21.2.1",
    "@cmusei/crucible-common": "0.4.3",
    "@datorama/akita": "^8.0.0",
    "@datorama/akita-ng-router-store": "^7.0.0",
    "@datorama/akita-ngdevtools": "^7.0.0",
    "@fortawesome/fontawesome-free": "^6.7.2",
    "@kolkov/angular-editor": "^3.0.0-beta.0",
    "@material/material-color-utilities": "^0.4.0",
    "@mdi/font": "^7.4.47",
    "@microsoft/signalr": "^8.0.7",
    "@ngxmc/datetime-picker": "^20.1.0",
    "@types/lodash": "^4.17.20",
    "ajv": "^8.6.0",
    "bootstrap": "^5.3.8",
    "bootstrap-scss": "^5.3.8",
    "core-js": "^3.47.0",
    "deep-copy-ts": "^0.5.4",
    "eventsource": "^1.1.1",
    "lodash": "^4.17.21",
    "material-design-icons": "^3.0.1",
    "ngx-clipboard": "^15.1.0",
    "oidc-client-ts": "^2.4.0",
    "rxjs": "^7.8.1",
    "rxjs-compat": "^6.6.7",
    "tslib": "^2.4.1",
    "uuid": "^8.3.2",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.1",
    "@angular-eslint/builder": "21.3.0",
    "@angular-eslint/eslint-plugin": "21.3.0",
    "@angular-eslint/eslint-plugin-template": "21.3.0",
    "@angular-eslint/schematics": "21.3.0",
    "@angular-eslint/template-parser": "21.3.0",
    "@angular/cli": "^21.2.1",
    "@angular/compiler-cli": "^21.2.1",
    "@angular/language-service": "^21.2.1",
    "@openapitools/openapi-generator-cli": "^1.0.18-3.2.0",
    "@playwright/test": "^1.40.1",
    "@types/jasmine": "~3.7.7",
    "@types/jasminewd2": "~2.0.9",
    "@types/node": "^18.11.18",
    "@typescript-eslint/eslint-plugin": "^8.41.0",
    "@typescript-eslint/parser": "^8.41.0",
    "eslint": "^9.34.0",
    "eslint-plugin-import": "^2.32.0",
    "jasmine-core": "~3.7.1",
    "jasmine-spec-reporter": "~7.0.0",
    "rimraf": "^5.0.5",
    "ts-node": "~10.0.0",
    "typescript": "~5.9.3"
  }
}
